import { memo } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import { useRegisterSW } from 'virtual:pwa-register/react';

export const PwaUpdateToast = memo(() => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      // Poll for SW updates every hour. The interval is not cleaned up because
      // this component is mounted at the App root and never unmounts.
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
      }
    },
    onRegisterError(error) {
      console.error('[PWA] Service worker registration failed:', error);
    },
  });

  const handleRefresh = () => {
    updateServiceWorker(true);
  };

  const handleClose = () => {
    setNeedRefresh(false);
  };

  return (
    <Snackbar
      open={needRefresh}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="success"
        variant="filled"
        onClose={handleClose}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={handleRefresh}
            sx={{ fontWeight: 600 }}
          >
            Refresh
          </Button>
        }
        sx={{ width: '100%', alignItems: 'center' }}
      >
        A new version of SquareUp is available.
      </Alert>
    </Snackbar>
  );
});

PwaUpdateToast.displayName = 'PwaUpdateToast';
